import React from "react";
import "./Projects.scss";
import { data1, data2 } from "./ProjectsData";
import ProjectsContact from "./ProjectContact/ProjectContact";
import { Helmet } from "react-helmet";
import VideoSection from "../Home/YoutubeVideo";

const Projects = () => {
  return (
    <div className="projectMain">
      <Helmet>
        <title>Our Projects | E&I Engineers' Success Stories</title>
        <meta
          name="description"
          content="Browse through our successful projects at E&I Engineers. See how we have delivered exceptional electrical engineering solutions, from substation erection to high mast erection and maintenance services."
        />
      </Helmet>
      <section className="projectSection">
        <h1 className="title slide-bottom">E&I Engineers Projects</h1>
        <div className="directContracts">
          <h2 className="subheading slide-right">Current Project</h2>
            
            <div className="projectColumn">
              <div className="picPan opacityF2T slide-left">
                <img
                  src="./images/projects/eandi-work-BSL-2025.jpg"
                  alt="SAIL BOKARO STEEL CITY JHARKHAND"
                  className="project-image"
                />
              </div>
              <div className="textPan slide-left">
                <h2 className="heading">BSL - HBS AND FURNACE AREAS</h2>
                <h3>Client: 'Mck Kutty Engineers PVT LTD'</h3>
                <h3>Site: SAIL BOKARO STEEL CITY JHARKHAND</h3>
                <div className="project-description">
                  <strong>Project Overview</strong>
                  <br />
                  This project involved a comprehensive package of ELECTRICAL AND INSTRUMENTATION ERECTION, TESTING AND COMMISSIONING work within the critical Hot Blast Stove (HBS) and Furnace Areas of the Bokaro Steel Plant (BSL), a major unit of the Steel Authority of India Limited (SAIL). The primary goal was to ensure the successful integration and operational readiness of new or upgraded plant facilities vital for steel production.
                  <br /><br /><br />
                  <strong className="highlight">Scope of Work by Area</strong>
                  <br /><br />
                  <strong>Hot Blast Stoves (HBS)</strong>
                  <ul>
                    <li>Erection, alignment, and termination of power and control cables for burners, blowers, instrumentation, and control panels.</li>

                    <li>Installation of sophisticated field instrumentation, including temperature sensors, pressure transmitters, flow meters, and control valves.</li>

                    <li>Testing and commissioning of the stove heating and changeover sequence control systems.</li>

                    <li>Loop checking and functional testing of all electrical and instrumentation components.</li>

                  </ul>
                  <strong>Furnace Areas (Blast Furnace/Ancillary Units):</strong>
                  <ul>
                    <li>Erection and commissioning of electrical equipment such as motor control centers (MCCs), distribution boards, and lighting systems.</li>
                    <li>Installation and calibration of critical process control instrumentation for monitoring and regulating furnace parameters (e.g., hot metal temperature, burden distribution).</li>
                    <li>Erection of cable trays, conduits, and grounding systems across the project areas.</li>
                    <li>Pre-commissioning and commissioning assistance for the newly installed or revamped equipment.</li>
                  </ul>
                  
                  
                  <strong>Outcome</strong>
                  <br />
                  The project was executed successfully, adhering strictly to the client's specifications, quality standards, and challenging safety requirements within a live industrial environment. The comprehensive Electrical and Instrumentation services delivered ensured that the HBS and Furnace areas were fully commissioned and handed over for smooth, efficient, and reliable operation, directly supporting BSL's sustained steel production targets.
                </div>
              </div>
            </div>
            <hr />
            <div className="projectColumn">
              <div className="picPan opacityF2T slide-left">
                <img
                  src="./images/projects/BokaroSteelPlant.jpeg"
                  alt="Bokaro Steel Plant: 1264 m³ Blast Furnace Project"
                  className="project-image"
                />
              </div>
              <div className="textPan slide-left">
                <h2 className="heading">Esl steel limited ( ESL): 1264 m³ Blast Furnace Project</h2>
                <h3>Client: Mck Kutty Engineers PVT LTD</h3>
                <h3>Site: Vedanta Bokaro Jharkhand</h3>
                <div className="project-description">
                  <strong>Project Overview</strong>
                  <br />
                  Successful execution of comprehensive Electrical & Instrumentation (E&I) contracting works for the new 1264 m³ Blast Furnace at Bokaro, Jharkhand. Our team was responsible for the full installation, testing, and commissioning of a fully integrated E&I system, ensuring high operational efficiency and robust process safety across all critical operational units.
                  <br /><br /><br />
                  <strong className="highlight">Scope of Work by Area</strong>
                  <br /><br />
                  <strong>Stock House</strong>
                  <ul>
                    <li>Installation of power and control cabling.</li>
                    <li>Erection of MCC (Motor Control Center) and PLC (Programmable Logic Controller) panels.</li>
                    <li>Connection and testing of weighing systems.</li>
                    <li>Installation of level transmitters and conveyor instrumentation.</li>
                  </ul>
                  <strong>Skip Winch Room</strong>
                  <ul>
                    <li>Motor control wiring and installation of encoder feedback.</li>
                    <li>Wiring for safety interlocks and brake control circuits.</li>
                    <li>Installation of local and remote operation wiring.</li>
                  </ul>
                  <strong>BLT (Bell Less Top)</strong>
                  <ul>
                    <li>Drive control wiring and speed monitoring setup.</li>
                    <li>Installation of pull cord switches and belt alignment sensors.</li>
                    <li>Installation and wiring of the emergency stop system.</li>
                  </ul>
                  <strong>Furnace Area</strong>
                  <ul>
                    <li>Execution of all electrical distribution and control wiring.</li>
                    <li>Installation and calibration of temperature and pressure instruments.</li>
                    <li>Wiring for critical process interlocks.</li>
                  </ul>
                  <strong>Cast House</strong>
                  <ul>
                    <li>Wiring for the hydraulic control system.</li>
                    <li>Installation of ladle and runner temperature sensors.</li>
                    <li>Installation of area lighting and power connections.</li>
                  </ul>
                  <strong>HBS (Hot Blast System)</strong>
                  <ul>
                    <li>Blower motor control wiring.</li>
                    <li>Installation of thermocouples and temperature transmitters.</li>
                    <li>Erection of control panels and performance of loop checking.</li>
                  </ul>
                  <strong>GCP (Gas Cleaning Plant)</strong>
                  <ul>
                    <li>Installation of level and pressure transmitters.</li>
                    <li>Connection of the dust monitoring system.</li>
                    <li>Wiring for motorized valve controls.</li>
                  </ul>
                  <strong>Technical Deliverables</strong>
                  <ul>
                    <li><strong>Cabling:</strong> Complete installation, termination, and testing of power, control, and instrumentation cables.</li>
                    <li><strong>Panel Works:</strong> Panel erection, internal wiring, and commissioning support.</li>
                    <li><strong>Instrumentation:</strong> Calibration and loop checking of all field instruments to ensure accuracy.</li>
                    <li><strong>System Integration:</strong> PLC/DCS integration with the client’s existing automation systems.</li>
                    <li><strong>Standards Adherence:</strong> Execution of all work in strict compliance with IEC, IS, and client-specific safety standards.</li>
                  </ul>
                  <strong>Outcome</strong>
                  <br />
                  The project resulted in a fully integrated Electrical & Instrumentation system that significantly enhanced operational efficiency, minimized downtime, and improved process safety for the 1264 m³ blast furnace. Our successful execution of the comprehensive E&I works was critical to the successful commissioning and long-term reliability of this key industrial facility.
                </div>
              </div>
            </div>
            <hr />
        </div>
        <div className="directContracts">
          <h2 className="subheading slide-right">Direct Contracts</h2>
          {data1.map((project, index) => (
            <React.Fragment key={index}>
              <div className="projectColumn">
                <div className="picPan opacityF2T slide-left">
                  <img
                    src={project.img}
                    alt={project.heading}
                    className="project-image"
                  />
                </div>
                <div className="textPan slide-left">
                  <h2 className="heading">{project.heading}</h2>
                  <h3>{project.place}</h3>
                  <p className="project-description">{project.description}</p>
                </div>
              </div>
              {index !== data1.length - 1 && <hr />}
            </React.Fragment>
          ))}
        </div>
        <div className="subContracts">
          <hr />
          <h2 className="subheading slide-right">Sub-Contracts</h2>
          {data2.map((project, index) => (
            <React.Fragment key={index}>
              
              <div className="projectColumn">
                <div className="picPan opacityF2T slide-left">
                  <img
                    src={project.img}
                    alt={project.heading}
                    className="project-image"
                  />
                </div>
                <div className="textPan slide-left">
                  <h2 className="heading">{project.heading}</h2>
                  <h3>{project.place}</h3>
                  <p className="project-description">{project.description}</p>
                </div>
              </div>
              {index !== data2.length - 1 && <hr />}
            </React.Fragment>
          ))}
        </div>
      </section>
      <VideoSection />
      <ProjectsContact />
    </div>
  );
};

export default Projects;
